// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Host component styling */
:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}
:host:focus-within .order-item {
  box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.3);
  outline: 2px solid var(--ion-color-primary);
}

/* Order item card */
.order-item {
  width: 100%;
  background: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0px 1.95px 7.3px 0px rgba(13, 71, 161, 0.1490196078);
  position: relative;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  /* Image section */
  /* Reset padding on columns */
  /* Item name and price typography */
  /* Container for flexible text content */
}
.order-item:hover {
  box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.2);
}
.order-item .img_section {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-item .img_section .product-image {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  object-fit: contain;
}
.order-item ion-col {
  padding: 0 !important;
}
.order-item .order-article-name,
.order-item .article-price {
  font-size: 16px;
  color: var(--ion-color-secondary);
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  font-family: AppFontBold, sans-serif;
}
.order-item .flex-text {
  min-height: 50px;
  padding: 5px 0;
}

/* Action buttons container */
.icons_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Edit and delete buttons section */
.edit_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* Button styling */
}
.edit_section .edit-btn {
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Icon sizing */
}
.edit_section .edit-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.edit_section .edit-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.edit_section .edit-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.edit_section .edit-btn:active {
  transform: scale(0.95);
}
.edit_section .edit-btn ion-icon {
  height: 30px;
  width: 30px;
}

/* Quantity selector */
.quantity-selector {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* Quantity text */
  /* Quantity buttons */
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  margin: 0 8px;
}
.quantity-selector .quantity-btn {
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Icon sizing */
}
.quantity-selector .quantity-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-selector .quantity-btn:active {
  transform: scale(0.95);
}
.quantity-selector .quantity-btn ion-icon {
  height: 30px;
  width: 30px;
  margin: 0;
}

/* Vertical centering utility */
.center-vertical {
  display: flex;
  align-items: center;
}

/* Option details */
.option-name {
  padding-bottom: 5px;
  margin: 0;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.option-name .option-price {
  font-weight: bold;
}

/* Price and quantity row spacing */
.price-quantity-row {
  margin-top: 5px;
}

/* Item note styling */
.note {
  font-style: italic;
  font-size: 13px;
  color: var(--ion-color-medium);
  margin-top: 5px;
}

/* High contrast mode enhancements */
.bsg-high-contrast .order-item {
  border: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .order-item:focus-within {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .order-article-name,
.bsg-high-contrast .article-price,
.bsg-high-contrast .option-name,
.bsg-high-contrast .quantity {
  color: black !important;
}
.bsg-high-contrast .edit-btn:focus,
.bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .edit-btn ion-icon,
.bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}
.bsg-high-contrast .note {
  color: black;
  border-top: 1px solid black;
  padding-top: 5px;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .order-item .img_section .product-image {
    width: 80px;
    height: 80px;
  }
  .order-item .order-article-name,
  .order-item .article-price {
    font-size: 14px;
  }
  .order-item .option-name {
    font-size: 12px;
  }
  .order-item .quantity {
    font-size: 16px;
  }
  .order-item .quantity-btn ion-icon,
  .order-item .edit-btn ion-icon {
    height: 24px;
    width: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADD;;AAIA,2BAAA;AACA;EACC,cAAA;EACA,WAAA;AADD;AAGC;EACC,mBAAA;AADF;AAIC;EACC,kDAAA;EACA,2CAAA;AAFF;;AAMA,oBAAA;AACA;EACC,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gEAAA;EACA,kBAAA;EACA,qDACC;EAOD,kBAAA;EAgBA,6BAAA;EAKA,mCAAA;EAUA,wCAAA;AAtCD;AAGC;EACC,kDAAA;AADF;AAKC;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAKE;EACC,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAHH;AAQC;EACC,qBAAA;AANF;AAUC;;EAEC,eAAA;EACA,iCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,SAAA;EACA,oCAAA;AARF;AAYC;EACC,gBAAA;EACA,cAAA;AAVF;;AAcA,6BAAA;AACA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAXD;;AAcA,oCAAA;AACA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AAZD;AAaC;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2DACC;EAGD,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,gBAAA;AAhCF;AAWE;EACC,2CAAA;EACA,mBAAA;AATH;AAaE;EACC,2CAAA;EACA,mBAAA;AAXH;AAeE;EACC,qCAAA;AAbH;AAiBE;EACC,sBAAA;AAfH;AAmBE;EACC,YAAA;EACA,WAAA;AAjBH;;AAsBA,sBAAA;AACA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,kBAAA;EAQA,qBAAA;AA3BD;AAoBC;EACC,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;AAlBF;AAsBC;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2DACC;EAGD,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,gBAAA;AAzCF;AAoBE;EACC,2CAAA;EACA,mBAAA;AAlBH;AAsBE;EACC,2CAAA;EACA,mBAAA;AApBH;AAwBE;EACC,qCAAA;AAtBH;AA0BE;EACC,sBAAA;AAxBH;AA4BE;EACC,YAAA;EACA,WAAA;EACA,SAAA;AA1BH;;AA+BA,+BAAA;AACA;EACC,aAAA;EACA,mBAAA;AA5BD;;AA+BA,mBAAA;AACA;EACC,mBAAA;EACA,SAAA;EACA,eAAA;EACA,iCAAA;AA5BD;AA8BC;EACC,iBAAA;AA5BF;;AAgCA,mCAAA;AACA;EACC,eAAA;AA7BD;;AAgCA,sBAAA;AACA;EACC,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;AA7BD;;AAgCA,oCAAA;AAEC;EACC,uBAAA;EACA,gBAAA;AA9BF;AAgCE;EACC,0BAAA;AA9BH;AAkCC;;;;EAIC,uBAAA;AAhCF;AAqCE;;EACC,0BAAA;EACA,gBAAA;AAlCH;AAqCE;;EACC,YAAA;AAlCH;AAsCC;EACC,YAAA;EACA,2BAAA;EACA,gBAAA;AApCF;;AAwCA,2BAAA;ACvQE;ED0QA;IACC,WAAA;IACA,YAAA;EAtCD;EAyCA;;IAEC,eAAA;EAvCD;EA0CA;IACC,eAAA;EAxCD;EA2CA;IACC,eAAA;EAzCD;EA8CC;;IACC,YAAA;IACA,WAAA;EA3CF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n/* Host component styling */\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t&:focus-within .order-item {\n\t\tbox-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.3);\n\t\toutline: 2px solid var(--ion-color-primary);\n\t}\n}\n\n/* Order item card */\n.order-item {\n\twidth: 100%;\n\tbackground: white;\n\tborder-radius: 10px;\n\tpadding: 10px;\n\tbox-shadow: 0px 1.95px 7.3px 0px #0d47a126;\n\tposition: relative;\n\ttransition:\n\t\tbox-shadow 0.2s ease,\n\t\ttransform 0.2s ease;\n\n\t&:hover {\n\t\tbox-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.2);\n\t}\n\n\t/* Image section */\n\t.img_section {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t.product-image {\n\t\t\twidth: 100px;\n\t\t\theight: 100px;\n\t\t\tmargin: 0 auto;\n\t\t\tobject-fit: contain;\n\t\t}\n\t}\n\n\t/* Reset padding on columns */\n\tion-col {\n\t\tpadding: 0 !important;\n\t}\n\n\t/* Item name and price typography */\n\t.order-article-name,\n\t.article-price {\n\t\tfont-size: 16px;\n\t\tcolor: var(--ion-color-secondary);\n\t\theight: fit-content;\n\t\tmargin: 0;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\n\t/* Container for flexible text content */\n\t.flex-text {\n\t\tmin-height: 50px;\n\t\tpadding: 5px 0;\n\t}\n}\n\n/* Action buttons container */\n.icons_block {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n/* Edit and delete buttons section */\n.edit_section {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t/* Button styling */\n\t.edit-btn {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tpadding: 5px;\n\t\tcursor: pointer;\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin: 0 4px;\n\t\ttransition:\n\t\t\tbackground-color 0.2s ease,\n\t\t\ttransform 0.2s ease;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Keyboard focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover state */\n\t\t&:hover {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t}\n\n\t\t/* Active state */\n\t\t&:active {\n\t\t\ttransform: scale(0.95);\n\t\t}\n\n\t\t/* Icon sizing */\n\t\tion-icon {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t}\n\t}\n}\n\n/* Quantity selector */\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t/* Quantity text */\n\t.quantity {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 18px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tmargin: 0 8px;\n\t}\n\n\t/* Quantity buttons */\n\t.quantity-btn {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tpadding: 5px;\n\t\tcursor: pointer;\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttransition:\n\t\t\tbackground-color 0.2s ease,\n\t\t\ttransform 0.2s ease;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Keyboard focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover state */\n\t\t&:hover {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t}\n\n\t\t/* Active state */\n\t\t&:active {\n\t\t\ttransform: scale(0.95);\n\t\t}\n\n\t\t/* Icon sizing */\n\t\tion-icon {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n}\n\n/* Vertical centering utility */\n.center-vertical {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Option details */\n.option-name {\n\tpadding-bottom: 5px;\n\tmargin: 0;\n\tfont-size: 14px;\n\tcolor: var(--ion-color-secondary);\n\n\t.option-price {\n\t\tfont-weight: bold;\n\t}\n}\n\n/* Price and quantity row spacing */\n.price-quantity-row {\n\tmargin-top: 5px;\n}\n\n/* Item note styling */\n.note {\n\tfont-style: italic;\n\tfont-size: 13px;\n\tcolor: var(--ion-color-medium);\n\tmargin-top: 5px;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t.order-item {\n\t\tborder: 2px solid black;\n\t\tbox-shadow: none;\n\n\t\t&:focus-within {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\t}\n\n\t.order-article-name,\n\t.article-price,\n\t.option-name,\n\t.quantity {\n\t\tcolor: black !important;\n\t}\n\n\t.edit-btn,\n\t.quantity-btn {\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t.note {\n\t\tcolor: black;\n\t\tborder-top: 1px solid black;\n\t\tpadding-top: 5px;\n\t}\n}\n\n/* Responsive adjustments */\n@include mobile {\n\t.order-item {\n\t\t.img_section .product-image {\n\t\t\twidth: 80px;\n\t\t\theight: 80px;\n\t\t}\n\n\t\t.order-article-name,\n\t\t.article-price {\n\t\t\tfont-size: 14px;\n\t\t}\n\n\t\t.option-name {\n\t\t\tfont-size: 12px;\n\t\t}\n\n\t\t.quantity {\n\t\t\tfont-size: 16px;\n\t\t}\n\n\t\t.quantity-btn,\n\t\t.edit-btn {\n\t\t\tion-icon {\n\t\t\t\theight: 24px;\n\t\t\t\twidth: 24px;\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
